import { type CSSProperties, type ReactNode, forwardRef } from 'react'
import PlentyBody from '#app/components/typography/plenty-body'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { cn } from '#app/utils/misc'

interface FilterButtonProps {
	selectedCount?: number
	children?: ReactNode
	style?: CSSProperties
	isSelectorOpen?: boolean
	text?: string
	className?: string
	onClick?: () => void
	showChevron?: boolean // New prop
}

const Badge = ({ count, className }: { count: number; className: string }) => {
	return (
		<span
			className={cn(
				'flex h-6 w-8 items-center justify-center rounded-full bg-mint-green-50 text-[8px] font-bold leading-3 tracking-[-0.12px] text-green-90',
				className,
			)}
		>
			{count}
		</span>
	)
}
const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
	(
		{
			selectedCount = 0,
			text,
			className,
			children,
			isSelectorOpen,
			showChevron = true,
			...props
		},
		ref,
	) => {
		return (
			<Button
				className={cn(
					'h-11 w-full gap-8 text-[18px] leading-[1-375rem] md:w-auto md:gap-4 md:text-[22px] md:leading-7',
					className,
				)}
				ref={ref}
				variant="filter_button"
				{...props}
			>
				<div className="flex w-full items-center justify-between gap-2 ">
					<div className="flex items-center space-x-2">
						<PlentyBody size="md">{text}</PlentyBody>
						{selectedCount! > 0 && (
							<Badge count={selectedCount} className="mr-2" />
						)}
					</div>
					<Icon name="filter" size="md" className="block md:hidden " />
					{showChevron && (
						<Icon
							name="chevron-down"
							size="md"
							className={`transition-transform duration-200 ease-in-out ${
								isSelectorOpen ? 'rotate-180' : 'rotate-0'
							}`}
						/>
					)}
				</div>
			</Button>
		)
	},
)

FilterButton.displayName = 'FilterButton'
export { FilterButton }
